import { useEffect, useState } from 'react';
import {
  fetchPriestOrdersAPI,
  fetchCateringOrdersAPI,
  fetchTentOrdersAPI,
  fetchVenueOrdersAPI
} from '../Apiservices/Auth/cart/Addtocart_api';
import { useDispatch } from 'react-redux';
import { addServiceToOrder, clearEntireOrder } from '../store/cartbodydataslice';

export const useOrders = () => {
  const [orderLoading, setOrderLoading] = useState(true);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchOrders = async () => {
      setOrderLoading(true);
      try {
        // Clear existing orders
        dispatch(clearEntireOrder());

        // ============================================
        // 1. FETCH PRIEST ORDERS
        // ============================================
        const priestResponse = await fetchPriestOrdersAPI();
        const priestResult = priestResponse?.result || [];

        priestResult.forEach((eventItem) => {
          const eveId = eventItem.event_id;
          const eventName = eventItem.event_title;
          const event_start_date = eventItem.event_start_date;
          
          eventItem.priestItems.forEach((priestItem) => {
            const is_checked_out = priestItem.is_checked_out;
            const balance_to_be_paid = priestItem.balance_to_be_paid;
            const paid_amount = priestItem.paid_amount;
            const is_edit_allowed = priestItem.is_edit_allowed;
            const provider = priestItem.priest;
            const pricing = priestItem.pricing;
            const order_id = priestItem.id;
            
            dispatch(
              addServiceToOrder({
                eveId,
                eventname: eventName,
                event_start_date: event_start_date,
                type: 'priestData',
                item: {
                  ...priestItem,
                  is_checked_out: is_checked_out,
                  is_edit_allowed: is_edit_allowed,
                  paid_amount: paid_amount,
                  balance_to_be_paid: balance_to_be_paid,
                  is_cancel_in_progress: priestItem.is_cancel_in_progress,
                  is_canceled: priestItem.is_canceled,
                  refund_complete: priestItem.refund_complete,
                  refund_in_pending: priestItem.refund_in_pending,
                  refunded_amount: priestItem.refunded_amount,
                  provider_id: provider.id,
                  providername: provider.name,
                  price: pricing.price,
                  discountPrice: pricing.discountPrice,
                  validUpto: pricing.discountValidUpto,
                  gstAmount: pricing.gstAmount,
                  gstPercentage: pricing.gstPercentage,
                  totalAmount: pricing.totalAmount,
                  service_id: priestItem.service?.id,
                  order_id: order_id,
                  mobileNumber: provider.mobileNumber,
                  total_amount: priestItem.total_amount || pricing.totalAmount || 0,
                },
              })
            );
          });
        });

        // ============================================
        // 2. FETCH CATERING ORDERS
        // ============================================
        const cateringResponse = await fetchCateringOrdersAPI();
        
        if (cateringResponse?.data) {
          cateringResponse.data.forEach((orderitem) => {
            const eveId = orderitem.event_id;
            const eventname = orderitem.event_title;
            const event_start_date = orderitem.event_start_date;
            
            orderitem.catering_providers?.forEach((cateringitem) => {
              const dispatchPayload = {
                eveId,
                eventname: eventname,
                event_start_date: event_start_date,
                type: "cateringData",
                item: {
                  ...cateringitem,
                  provider_id: cateringitem.provider_id,
                  balance_to_be_paid: cateringitem.balance_to_be_paid,
                  is_checked_out: cateringitem.is_checked_out,
                  is_edit_allowed: cateringitem.is_edit_allowed,
                  paid_amount: cateringitem.paid_amount,
                  providername: `${cateringitem.first_name || ''} ${cateringitem.last_name || ''}`,
                  total_amount: cateringitem.total_amount || 0,
                  services: cateringitem.items?.map((item) => ({
                    ...item,
                    mapping_id: item.item_id,
                    service_id: item.category_id,
                    quantity: item.number_of_people,
                    price: item.regular_price,
                    discountPrice: item.discounted_price,
                    gst_amount: item.gst_amount,
                    gst_percentage: item.gst_percentage,
                    total_amount: item.total_amount,
                    validUpto: item.valid_until,
                    category: item.category?.name,
                    mealtype: item.meal?.name,
                    cuisine: item.type?.name
                  })) || [],
                },
              };

              try {
                dispatch(addServiceToOrder(dispatchPayload));
              } catch (dispatchErr) {
                console.error("Dispatch Error (addServiceToOrder Catering):", dispatchErr);
                console.log("Failed Dispatch Payload:", dispatchPayload);
              }
            });
          });
        }

        // ============================================
        // 3. FETCH TENT ORDERS
        // ============================================
        const tentResponse = await fetchTentOrdersAPI();
        
        if (tentResponse?.data) {
          tentResponse.data.forEach((orderitem) => {
            const eveId = orderitem.event_id;
            const eventname = orderitem.event_title;
            const event_start_date = orderitem.event_start_date;
            
            orderitem.tent_providers?.forEach((tentitem) => {
              const provider = tentitem;
              const pricingData = provider.pricing || {};
              
              dispatch(
                addServiceToOrder({
                  eveId,
                  eventname: eventname,
                  event_start_date: event_start_date,
                  type: 'tentHouseData',
                  item: {
                    ...tentitem,
                    provider_id: provider.provider_id,
                    balance_to_be_paid: provider.balance_to_be_paid,
                    is_checked_out: provider.is_checked_out,
                    is_edit_allowed: provider.is_edit_allowed,
                    paid_amount: provider.paid_amount,
                    providername: (provider.first_name ?? '') + ' ' + (provider.last_name ?? ''),
                    total_amount: provider.total_amount || 0,
                    services: tentitem.items?.map((item) => ({
                      ...item,
                      order_id: item.order_id,
                      mapping_id: item.mapping_id,
                      service_id: item.service_id,
                      quantity: item.quantity,
                      price: item.price,
                      discountPrice: item.discount_price,
                      validUpto: item.discount_valid_upto,
                    })) || [],
                  },
                })
              );
            });
          });
        }

        // ============================================
        // 4. FETCH VENUE ORDERS
        // ============================================
        const venueResponse = await fetchVenueOrdersAPI();
        console.log("Venue Orders Response:", venueResponse);

        if (venueResponse?.success && venueResponse?.data) {
          venueResponse.data.forEach((orderitem) => {
            const eveId = orderitem.event_id;
            const eventname = orderitem.event_title;
            const event_start_date = orderitem.event_start_date;
            
            orderitem.venueItems?.forEach((venueItem) => {
              // Transform food selections
              const foodSelections = venueItem.foodSelections?.map(food => ({
                id: food.id,
                menuId: food.menuId,
                guestCount: food.guestCount,
                pricePerPerson: food.pricePerPerson,
                subtotal: food.subtotal,
                menu: food.menu || { name: `Menu ${food.menuId}` },
              })) || [];

              // Transform drink selections
              const drinkSelections = venueItem.drinkSelections?.map(drink => ({
                id: drink.id,
                drinkOptionId: drink.drinkOptionId,
                guestCount: drink.guestCount,
                pricePerPerson: drink.pricePerPerson,
                subtotal: drink.subtotal,
                drinkOption: drink.drinkOption || { name: `Drink ${drink.drinkOptionId}` },
              })) || [];

              dispatch(
                addServiceToOrder({
                  eveId,
                  eventname: eventname,
                  event_start_date: event_start_date,
                  type: 'venueData',
                  item: {
                    ...venueItem,
                    id: venueItem.id,
                    cartId: venueItem.cartId,
                    venueId: venueItem.venueId,
                    spaceId: venueItem.spaceId,
                    provider_id: venueItem.providerId,
                    provider_name: venueItem.provider?.name || '',
                    provider_mobile: venueItem.provider?.mobileNumber || '',
                    provider_email: venueItem.provider?.emailId || '',
                    venue_name: venueItem.venue?.name || '',
                    venue_address: venueItem.venue?.address || '',
                    venue_description: venueItem.venue?.description || '',
                    section_name: venueItem.section?.name || '',
                    section_capacity: venueItem.section?.capacity || '',
                    pricing_type: venueItem.pricingType,
                    food_included: venueItem.foodIncluded,
                    outside_food_allowed: venueItem.outsideFoodAllowed,
                    no_of_guests: venueItem.noOfGuests,
                    from_date: venueItem.fromDate,
                    from_time: venueItem.fromTime,
                    to_date: venueItem.toDate,
                    to_time: venueItem.toTime,
                    rules_accepted: venueItem.rulesAccepted,
                    base_price: venueItem.basePrice,
                    food_total: venueItem.foodTotal,
                    drink_total: venueItem.drinkTotal,
                    subtotal: venueItem.subtotal,
                    gst_percentage: venueItem.gstPercentage || venueItem.gst_percentage || 18,
                    gst_amount: venueItem.gstAmount || venueItem.gst_amount || 0,
                    total_amount: venueItem.totalAmount || venueItem.total_amount || 0,
                    paid_amount: venueItem.paidAmount || venueItem.paid_amount || 0,
                    balance_to_be_paid: venueItem.balanceToBePaid || venueItem.balance_to_be_paid || 0,
                    is_checked_out: venueItem.isCheckedOut || venueItem.is_checked_out || false,
                    is_edit_allowed: venueItem.isEditAllowed || venueItem.is_edit_allowed || false,
                    is_canceled: venueItem.isCanceled || venueItem.is_canceled || false,
                    is_pay_later: venueItem.isPayLater || venueItem.is_pay_later || false,
                    refunded_amount: venueItem.refundedAmount || venueItem.refunded_amount || 0,
                    booking_date: venueItem.booking_date,
                    start_time: venueItem.start_time || venueItem.fromTime,
                    end_time: venueItem.end_time || venueItem.toTime,
                    guest_count: venueItem.guest_count || venueItem.noOfGuests,
                    foodSelections: foodSelections,
                    drinkSelections: drinkSelections,
                    pricing: venueItem.pricing || {
                      price: venueItem.subtotal || 0,
                      discount_price: venueItem.subtotal || 0,
                      gst_percentage: venueItem.gstPercentage || 18,
                      gst_amount: venueItem.gstAmount || 0,
                      total_amount: venueItem.totalAmount || 0,
                    },
                    paymentSummary: venueItem.paymentSummary || {
                      totalAmount: venueItem.totalAmount || 0,
                      paid: venueItem.paidAmount || 0,
                      balance: venueItem.balanceToBePaid || 0,
                      payable_now: venueItem.balanceToBePaid || 0,
                    },
                    venue: venueItem.venue || {},
                    section: venueItem.section || {},
                    provider: venueItem.provider || {},
                    total: venueItem.totalAmount || venueItem.total_amount || 0,
                  },
                })
              );
            });
          });
        }

      } catch (err) {
        console.error('Error loading orders:', err);
      }
      setOrderLoading(false);
    };

    fetchOrders();
  }, [refreshTrigger, dispatch]);

  const fetchAllOrders = () => setRefreshTrigger((prev) => prev + 1);

  const clearOrders = () => {
    dispatch(clearEntireOrder());
  };

  return {
    fetchAllOrders,
    clearOrders,
    orderLoading,
  };
};